<template>
    <UForm class="w-full mb-8" :schema="schema" :state="state" @submit="onSubmit">
        <div class="flex justify-between mb-4 px-2">
            <UiComponentTypography class-name="text-center" variant="caption">
                برای ثبت‌نام یا ورود ابتدا شماره موبایل خود را وارد نمایید
            </UiComponentTypography>
        </div>
        <UtilsFormBuilder form-size="xs" class="flex-wrap" :data="form" v-model="state" />
        <div class="flex justify-center mt-8">
            <UButton type="submit" :loading="isLoading" block size="md">
                <span>{{ $t("next") }}</span>
            </UButton>
        </div>
    </UForm>
</template>

<script lang="ts" setup>
import type { IForm } from "~/libs/types/general";
import { object, string, type InferType } from "yup";
import type { FormSubmitEvent } from "#ui/types";
import { addUsernameMethod } from "~/libs/validations/yup";
import username from "~/libs/schemas/auth/username.json";

addUsernameMethod();

const emits = defineEmits(["send-data"]);

const props = defineProps({
    isLoading: {
        type: Boolean,
        default: false,
    },
});

const form: Ref<IForm<any>[]> = ref(username as IForm<any>[]);

const schema = object({
    username: string().username().required("وارد کردن این فیلد الزامی‌ست"),
});

type Schema = InferType<typeof schema>;

const state = reactive({
    username: undefined,
});

async function onSubmit(event: FormSubmitEvent<Schema>) {
    if (event.data) emits("send-data", event.data.username);
}
</script>

<style></style>
